import { EColors } from "common/styles";
import { Styled } from "components/Styled";
import { ImageFuel, StyledCardItem } from "./styled";

export type TCard = {
  title: string;
  describe: string;
  src: string;
};

export const FuelCard = ({ item }:{item: TCard }) => {
  return (
    <StyledCardItem>
      <Styled.H3 color={EColors.white}>{item.title}</Styled.H3>
      <Styled.PBody1 color={EColors.white}>{item.describe}</Styled.PBody1>
      <ImageFuel src={`${item.src}`} alt='fuel'/>
    </StyledCardItem>
  );
};
